module.exports = __webpack_public_path__ + "media/img/apple-icon-180x180-bd6662a546004c8b61603b2f44016f9a.png";